import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import word from "assets/img/file_word.png";
import excel from "assets/img/file_excel.png";
import pdf from "assets/img/file_pdf.png";
import ppt from "assets/img/file_pp.png";
import video from "assets/img/file_video.png";
import other from "assets/img/file_other.png";
import * as LotActionType from "../constants";
import { Dropdown } from "../../components/Dropdown/Dropdown";
import { Panel, Table } from "react-bootstrap";
import Moment from "moment";
import "../add-doc-modal.scss";

export class EditDocumentModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    dispatch: PropTypes.func,
    HomeownerDocumentCategory: PropTypes.array,
    lot: PropTypes.object,
    documentType: PropTypes.object,
    SelectedEditDocument: PropTypes.object,
    getDocumentByCategory: PropTypes.func,
    fetchListDocumentType: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      documents: this.props.SelectedEditDocument
        ? this.props.SelectedEditDocument
        : {},
      uploading: false,
      uploadProgress: 0,
      uploadMessage: "",
      selectedLotId: null,
      lotDetails: null,
      showDocumentInfo: true,
      lot: this.props.lot,
      editingState: {},
      documentCategory: this.props.documentType || null,
      expandedPanels: {},
      editCategoryIndex: null,
      showConfirmDeleteModal: false,
      documentToDelete: null,
      categoryError: "",
      nameError: "",
    };
  }

  componentDidMount() {
    const { SelectedEditDocument } = this.props;

    if (SelectedEditDocument) {
      this.setState((prevState) => ({
        documents: [SelectedEditDocument],
        expandedPanels: {
          ...prevState.expandedPanels,
          [SelectedEditDocument.id]: true,
        },
      }));
    }
  }

  togglePanel = () => {
    const { SelectedEditDocument } = this.props;
    this.setState((prevState) => ({
      expandedPanels: {
        ...prevState.expandedPanels,
        [SelectedEditDocument.id]:
          !prevState.expandedPanels[SelectedEditDocument.id],
      },
    }));
  };

  onEditStart = (index) => {
    const { SelectedEditDocument } = this.props;

    this.setState((prevState) => ({
      editingState: {
        ...prevState.editingState,
        [SelectedEditDocument.id]: true,
      },
    }));
  };
  onEditCancel = (index) => {
    this.setState((prevState) => {
      const updatedDocs = prevState.documents.map((doc) =>
        doc.id === index ? { ...doc, overrideName: undefined } : doc
      );

      return {
        editingState: {
          ...prevState.editingState,
          [index]: false,
        },
        documents: updatedDocs,
        nameError: "",
      };
    });
  };

  onFileNameChange = (id, newName) => {
    this.setState((prevState) => {
      const doc = prevState.documents.find((d) => d.id === id);
      const originalName = doc.overrideName || doc.fileName;
  
      const originalExt = originalName.includes(".")
        ? originalName.substring(originalName.lastIndexOf(".") + 1)
        : "";
  
      let nameWithoutExt = newName;
      // If the user tried to enter an extension, strip it
      if (newName.includes(".")) {
        nameWithoutExt = newName.substring(0, newName.lastIndexOf("."));
      }
  
      const finalName =
        originalExt && nameWithoutExt.trim()
          ? `${nameWithoutExt.trim()}.${originalExt}`
          : nameWithoutExt.trim();
  
      return {
        documents: prevState.documents.map((d) =>
          d.id === id ? { ...d, overrideName: finalName } : d
        ),
        nameError: nameWithoutExt.trim() !== "" ? "" : "Please enter a document title.",
      };
    });
  };
  
  onSubmit = () => {
    const { documents, lot, documentCategory } = this.state;
    const { SelectedEditDocument } = this.props;
    const { builderProfile } = lot.extensionValue;

    let hasError = false;
    const categoryError = "";
    const nameError = "";

    const updatedDoc = documents.find(
      (doc) => doc.id === SelectedEditDocument.id
    );

    const fileNameToUse =
      updatedDoc.overrideName !== undefined
        ? updatedDoc.overrideName.trim()
        : SelectedEditDocument.fileName.trim();
    const category = this.state.documentCategory;
    const baseFileName = fileNameToUse.substring(0, fileNameToUse.lastIndexOf("."));

    
    if (!fileNameToUse && !category) {
      this.setState({
        nameError: "Please enter a document title.",
        categoryError: "Please select a category.",
      });
      return;
    } else if (!fileNameToUse) {
      this.setState({ nameError: "Please enter a document title." });
      return;
    } else {
      if (!category) {
        this.setState({ categoryError: "Please select a category." });
        return;
      }
    }
    if (hasError) {
      this.setState({ nameError, categoryError });
      return;
    }

    const data = {
      FileName: fileNameToUse,
      LotId: lot.id,
      DocId: SelectedEditDocument.id,
      CategoryId: category.value,
    };

    this.setState({ uploading: true, uploadProgress: 0, errorMessage: "" });

    this.props.dispatch({
      type: LotActionType.EDIT_DOCUMENT_BY_CATEGORY_ASYNC,
      params: {
        headers: {
          url: builderProfile.builderHost,
        },
        data: data,
      },
      callback: (data) => {
        this.setState({ uploading: false }, () => {
          this.props.fetchListDocumentType();
          this.props.closeModal();
        });
      },
    });
  };

  hasChanges = () => {
    const { SelectedEditDocument } = this.props;
    const { documents, documentCategory } = this.state;

    const currentDoc = documents.find(
      (doc) => doc.id === SelectedEditDocument.id
    );
    const originalName =
      SelectedEditDocument.overrideName || SelectedEditDocument.fileName;
    const currentName =
      currentDoc.overrideName !== undefined
        ? currentDoc.overrideName
        : SelectedEditDocument.fileName;

    const originalCategoryId = SelectedEditDocument.categoryId;
    const currentCategoryId = documentCategory ? documentCategory.value : null;

    return (
      currentName.trim() !== originalName.trim() ||
      currentCategoryId !== originalCategoryId
    );
  };

  onEditTabName = (index) => {
    this.setState({ editCategoryIndex: index, documentCategory: "" }, () => {
      this.fetchListDocumentType;
    });
  };

  fetchListDocumentType = () => {
    const { lot } = this.state;
    const { builderProfile } = lot.extensionValue;

    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_DOCUMENT_CATEGORY_ASYNC,
      params: {
        headers: {
          url: builderProfile.builderHost,
        },
        lotId: lot.value,
      },
    });
  };

  renderFileTypeIcon = (item) => {
    const { SelectedEditDocument } = this.props;
    const extWord = ["doc", "docx"];
    const extExcel = ["xls", "xlsx"];
    const extPpt = ["ppt", "pptx"];
    const imageExtensions = [
      "jpg",
      "jpeg",
      "png",
      "gif",
      "bmp",
      "webp",
      "tiff",
      "tif",
      "svg",
      "ico",
      "heic",
      "avif",
    ];
    const extVideo = ["mp4", "m4v", "mid", "mkv", "webm", "mov", "avi", "wmv"];

    let ext = "";
    if (
      SelectedEditDocument &&
      SelectedEditDocument.fileName &&
      SelectedEditDocument.fileName.includes(".")
    ) {
      ext = SelectedEditDocument.fileName.split(".").pop().toLowerCase();
    }

    if (extWord.includes(ext)) {
      return word;
    } else if (extExcel.includes(ext)) {
      return excel;
    } else if (extPpt.includes(ext)) {
      return ppt;
    } else if (extVideo.includes(ext)) {
      return video;
    } else if (ext === "pdf") {
      return pdf;
    } else if (imageExtensions.includes(ext)) {
      return SelectedEditDocument.documentUrl;
    } else {
      return other;
    }
  };

  removeFile = (id) => {
    const { lot } = this.state;
    const { builderProfile } = lot.extensionValue;

    this.props.dispatch({
      type: LotActionType.DELETE_HOMEOWNER_DOCUMENT_ASYNC,
      params: {
        headers: {
          url: builderProfile.builderHost,
        },
        documentID: id,
      },
      callback: () => {
        this.props.fetchListDocumentType();
        this.props.closeModal();
      },
    });
  };

  handleDelete = (document) => {
    this.setState({
      showConfirmDeleteModal: true,
      documentToDelete: document,
      menuOpenId: null,
    });
  };

  onSelectCategory = (event) => {
    this.setState({
      documentCategory: event.value,
      categoryError: "",
    });
  };

  render() {
    const { documents, lot, documentType, documentCategory } = this.state;
    const {
      isOpen,
      closeModal,
      SelectedEditDocument,
      HomeownerDocumentCategory,
    } = this.props;

    return (
      <Modal
        show={isOpen}
        onHide={closeModal}
        backdrop="static"
        dialogClassName="slide-in-modal"
        className="modal-right"
      >
        <Modal.Header className="modal-header-profile">
          <div className="modal-header">
            <i
              className="fa fa-chevron-left arrow-btn"
              aria-hidden="true"
              onClick={closeModal}
            ></i>
            <Modal.Title className="modal-title-custom">
              Edit Document
            </Modal.Title>
          </div>
        </Modal.Header>

        <Modal.Body className="modal-body-add-doc scrollable-modal-body">
          <div className="file-entry">
            <div className="add-document-list">
              <div className="file-summary">
                <img
                  src={this.renderFileTypeIcon(SelectedEditDocument)}
                  className="doc-icon"
                />
                <div className="file-info">
                  <p className="file-name" style={{ marginBottom: "0px" }}>
                    {SelectedEditDocument.fileName}
                  </p>
                  <span className="sub-title-doc">{lot.text}</span>
                  <span className="sub-title-doc">
                    {Moment(SelectedEditDocument.createdDate).format(
                      "MM/DD/YYYY"
                    )}
                  </span>
                </div>
              </div>

              <Panel>
                <Panel.Heading
                  onClick={() => this.togglePanel(SelectedEditDocument.id)}
                >
                  <div className="accordion-header-add-edit">
                    <span>
                      <i
                        class="fa fa-file-text-o doc-icon"
                        aria-hidden="true"
                      ></i>

                      <span className="lot-titles">Document Info</span>
                    </span>
                    <span
                      className={`glyphicon arrow-icon ${
                        this.state.expandedPanels[SelectedEditDocument.id]
                          ? "glyphicon-chevron-up"
                          : "glyphicon-chevron-down"
                      }`}
                    ></span>
                  </div>
                </Panel.Heading>

                {this.state.expandedPanels[SelectedEditDocument.id] && (
                  <Panel.Body>
                    <Table bordered className="accordion-table-doc">
                      <tbody>
                        <tr>
                          <th>Title</th>
                          <td>
                            {this.state.editingState[
                              SelectedEditDocument.id
                            ] ? (
                              <span>
                                {(() => {
                                  const matchedDoc = this.state.documents.find(
                                    (doc) => doc.id === SelectedEditDocument.id
                                  );
                                  const fileName =
                                    matchedDoc &&
                                    matchedDoc.overrideName !== undefined
                                      ? matchedDoc.overrideName
                                      : SelectedEditDocument.fileName;

                                  return (
                                    <input
                                    type="text"
                                    value={(fileName || "").split(".")[0]} // Show only the title
                                    maxLength="40"
                                    onChange={(e) =>
                                      this.onFileNameChange(SelectedEditDocument.id, e.target.value)
                                    }
                                    onKeyDown={(e) => {
                                      if (e.key === ".") e.preventDefault();
                                    }}
                                    style={{ width: "80%" }}
                                  />
                                  
                                  );
                                })()}

                                <i
                                  className="fa fa-times"
                                  style={{
                                    marginLeft: 10,
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    this.onEditCancel(SelectedEditDocument.id)
                                  }
                                ></i>
                              </span>
                            ) : (
                              <span>
                                {SelectedEditDocument.overrideName ||
                                  SelectedEditDocument.fileName}
                                <i
                                  className="fa fa-pencil edit-icon"
                                  style={{ marginLeft: 10, cursor: "pointer" }}
                                  onClick={() =>
                                    this.onEditStart(SelectedEditDocument.id)
                                  }
                                ></i>
                              </span>
                            )}
                            {this.state.nameError && (
                              <div
                                className="validation-message"
                                style={{
                                  color: "red",
                                }}
                              >
                                {this.state.nameError}
                              </div>
                            )}
                          </td>
                        </tr>

                        <tr>
                          <th>Property</th>
                          <td>
                            <span>{lot.text}</span>
                          </td>
                        </tr>
                        <tr>
                          <th>Category</th>
                          <td>
                            {this.state.editCategoryIndex ==
                            SelectedEditDocument.id ? (
                              <div className="select-category">
                                <Dropdown
                                  onChange={this.onSelectCategory}
                                  filter={true}
                                  className="filestring-dropdown filter-dropdown"
                                  options={HomeownerDocumentCategory}
                                  optionLabel="text"
                                  onRemote={this.fetchListDocumentType}
                                  value={this.state.documentCategory}
                                  name="category"
                                  placeholder="-- Please select"
                                  style={{
                                    width: "80%",
                                    display: "inline-block",
                                  }}
                                />
                                {this.state.categoryError && (
                                  <div
                                    className="validation-message"
                                    style={{
                                      color: "red",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    {this.state.categoryError}
                                  </div>
                                )}
                              </div>
                            ) : (
                              <span>
                                <span className="category-panel"></span>{" "}
                                {documentCategory ? documentCategory.text : ""}
                                <span
                                  id={SelectedEditDocument.value}
                                  className="fa fa-pencil tab-title-edit-icon"
                                  style={{
                                    color: "#4a4a4a",
                                    marginLeft: 5,
                                  }}
                                  onClick={() =>
                                    this.onEditTabName(SelectedEditDocument.id)
                                  }
                                />
                              </span>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Panel.Body>
                )}
              </Panel>

              <button
                className="delete-btn"
                onClick={() => this.handleDelete(SelectedEditDocument)}
              >
                Delete File
              </button>
            </div>
          </div>
          {this.state.errorMessage && (
            <div
              className="error-message"
              style={{ color: "red", marginBottom: "10px" }}
            >
              {this.state.errorMessage}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="modal-footer-addDocument">
          {this.state.documents.length > 0 ? (
            <button
              type="button"
              className="save-doc-btn"
              onClick={this.onSubmit}
              disabled={!this.hasChanges()}
            >
              Update Document
            </button>
          ) : (
            ""
          )}
        </Modal.Footer>
        {this.state.showConfirmDeleteModal && (
          <Modal
            dialogClassName="confirm-cancel-save-eoc-template-dialog"
            show={this.state.showConfirmDeleteModal}
            centered="true"
            size="sm"
          >
            <Modal.Header>
              <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete this document?</p>
            </Modal.Body>
            <Modal.Footer>
              <div className="suspend-group-btn" style={{ float: "left" }}>
                <button
                  className="btn btn-danger"
                  onClick={() => {
                    const { documentToDelete } = this.state;
                    this.removeFile(documentToDelete.id);
                    this.setState({
                      showConfirmDeleteModal: false,
                      documentToDelete: null,
                    });
                  }}
                >
                  Yes, Delete
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={() =>
                    this.setState({
                      showConfirmDeleteModal: false,
                      documentToDelete: null,
                    })
                  }
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    LotDocuments: state.LotStore.LotDocuments,
    HomeownerDocumentCategory: state.LotStore.HomeownerDocumentCategory,
  };
};

export default connect(mapStateToProps)(EditDocumentModal);



// WEBPACK FOOTER //
// ./src/Lots/Components/EditDocumentModal.js